import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useSignupStore = create(
  persist(
    (set) => ({
      reservationId: null,
      data: {
        founderName: "",
        email: "",
        company: "",
        role: "Founder/CEO",
        companySize: "2-10",
        salesMotion: "Mixed",
        instanceType: "saas",
        agreeTOS: false,
        agreePrivacy: false,
      },
      setData: (patch) => set((s) => ({ data: { ...s.data, ...patch } })),
      createReservation: (data) => {
        const reservationId = `rsv-${Math.random().toString(36).slice(2, 10)}`;
        set({ data, reservationId });
        return reservationId;
      },
    }),
    { name: "sellix.signup.v1" },
  ),
);
